import { render, staticRenderFns } from "./marketFacility.vue?vue&type=template&id=b7b89a6c&scoped=true"
import script from "./marketFacility.vue?vue&type=script&lang=js"
export * from "./marketFacility.vue?vue&type=script&lang=js"
import style0 from "./marketFacility.vue?vue&type=style&index=0&id=b7b89a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b89a6c",
  null
  
)

export default component.exports